import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getMySubmission, MySubmission } from "../api/mySubmissions";
import ReadOnlySubmission from "../components/ReadOnlySubmission";

export default function MySubmissionDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [sub, setSub] = useState<MySubmission | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    getMySubmission(id)
      .then(setSub)
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"));
  }, [id]);

  if (error) return <div className="container"><div className="banner-error">{error}</div></div>;
  if (!sub) return <div className="container"><p>Loading…</p></div>;

  const data = sub.data ?? {};
  const projectName = (data.projectName as string) || "(untitled)";
  const jobNumber = data.jobNumber as string | undefined;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <Link to="/submissions" className="back-link">← My submissions</Link>
          <h1>{projectName} {jobNumber && <span className="job-num">#{jobNumber}</span>}</h1>
          <div className="hint">Submitted on {new Date(sub.submittedAt).toLocaleString()}</div>
        </div>
      </div>
      <ReadOnlySubmission data={data} />
    </div>
  );
}
